export default {
  "popular": [
    {
      "name": "Stairs madness",
      "usersCount": 0,
      "heightmap": `
      xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx3xx
      xwvutsrqponmlkjihgfedcba9876543333
      wwvutsrqponmlkjihgfedcba9876543333
      xwvutsrqponmlkjihgfedcba9876543333
      xbbba98765432100000000000000000222
      xxxxxxxxxxxxxxx0000000000000000111
      x000000000000000000000000000000000
      x000000000000000000000000000000000
      x000000000000000000000000000000000
      x000000000000000000000000000000000
      x000000000000000000000000000000000
      x000000000000000000000000000000000
      xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx`
    },
    {
      "name": "Mouse Hole",
      "usersCount": 10,
      "heightmap": "000"
    },
    {
      "name": "Run and Jump!",
      "usersCount": 2,
      "heightmap": `
        000
        000
        000
        000
        000
        000
        xxx
        000
        000
        xxx
        000
        xxx
      `
    },
    {
      "name": "Pyramid (a slow one)",
      "usersCount": 0,
      "heightmap": `
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111222222222222222111111
        111111222222333222222111111
        111111223333444333322111111
        111111223333444333322111111
        111111222222333222222111111
        111111222222222222222111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
        111111111111111111111111111
      `
    }
  ]
}
